import { Text, View } from "@react-pdf/renderer";
import React from "react";
import { TFunction } from "react-i18next";
import { DiagramInfoField } from "../../types";
import { pdfStyles } from "./styles";

export const resolvePdfValue = (value: string, t: TFunction) =>
  value.startsWith("WORK_ORDER.") ? t(value) : value;

export const formatPdfLabel = (label: string) => `: ${label}`;

type PdfFieldRowProps = {
  labelKey: string;
  value: string;
  t: TFunction;
};

export const PdfFieldRow = ({ labelKey, value, t }: PdfFieldRowProps) => (
  <View style={pdfStyles.topInfoFieldRow}>
    <Text style={pdfStyles.fieldValue}>{resolvePdfValue(value, t)}</Text>
    <Text style={pdfStyles.fieldLabel}>{formatPdfLabel(t(labelKey))}</Text>
  </View>
);

type PdfInfoCardProps = {
  titleKey: string;
  fields: DiagramInfoField[];
  t: TFunction;
};

export const PdfInfoCard = ({ titleKey, fields, t }: PdfInfoCardProps) => (
  <View style={pdfStyles.halfCard}>
    <Text style={pdfStyles.cardTitle}>{t(titleKey)}</Text>
    <View style={pdfStyles.topInfoCardBody}>
      {fields.map((field) => (
        <PdfFieldRow
          key={field.labelKey}
          labelKey={field.labelKey}
          value={field.value}
          t={t}
        />
      ))}
    </View>
  </View>
);
